export default "<span ng-class=\"{ 'label success' : 2 == vm.kpiCheckResults.status, 'label alert' : 1 == vm.kpiCheckResults.status }\"> <span ng-if=vm.loading>...</span> <span ng-if=!vm.loading>{{ vm.kpiCheckResults.result ? vm.kpiCheckResults.result + '%' : 'n/a' }}</span> <span ng-if=!vm.loading>{{ vm.kpiCheckResults.checkName }}</span> </span>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/checkLists/checkListKPI.dashboard.tpl.html
// module id = 578
// module chunks = 0